import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { SetPointEventTypeEnum } from "../../common/enums/SetPointEventTypeEnum";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { IReferenceTimeZoneDTO } from "../global-data-service/Models";

export enum DateColumnTypeEnum {
    One = 1,
    Two = 2
}

export enum FileContainsTypeEnum {
    DataForSingleDevice = 1,
    DataForMultipleDevices = 2,
    DataForSingleWell = 3,
    DataForMultipleWells = 4,
    DataForSingleTank = 5,
    DataForMultipleTanks = 6,
}

export enum ImportTypeEnum {
    None = -1,
    Single = 1,
    Multiple = 2
}

export enum LogEntryTypeEnum {
    //[Description("All Tags Succesfully Processed")]
    AllTagsProcessed = 0,
    //[Description("Identifer Not matched to Organization Object")]
    IdentifierNotMatched = 1,
    //[Description("Invalid Data")]
    InvalidData = 2,
    //[Description("Invalid Date Time")]
    InvalidDateTime = 3,
    //[Description("Missing Date Time")]
    MissingDateTime = 4,
    //[Description("Tag Not Found for Object")]
    MissingTag = 5,
    //[Description("No Read Permissions")]
    NoReadPermissions = 6,
    //[Description("Object Not Active")]
    NotActive = 7,
    //[Description("Missing Identifier")]
    MissingIdentifier = 8,
    //[Description("Processing Error")]
    ProcessingError = 9
}

export interface IColumn {
    // Column Index
    id: number;
    name: string;
}

export interface IConfigImportFileParams {
    fileHasHeaderRow: boolean;
    fileName?: string;
    identifierColumn?: IColumn;
    importObjectType?: eLynxObjectTypeEnum;
    importType?: ImportTypeEnum;
    tagTypeColumns?: Array<IColumn>;
}

export interface IRunImportFileParams {
    configID: number;
    fileName: string;
    notificationID?: string;
    objectOverride?: IeLynxObject;
    skipVerification: boolean
}


export interface ITagTypesInUseOptions {
    dataType: eLynxObjectTypeEnum;
    objects: Array<IeLynxObject> | undefined;
    includeInternalTanks: boolean;
}


export interface ITagTypesParams {
    importFileParams: IConfigImportFileParams;
    tagTypesInUseOptions: ITagTypesInUseOptions;
}

export interface IFileStoreInfo {
    fileStoreBlobURI: string;
    fileStoreFileName: string;
}

export interface IFileSaveResult {
    fileStoreInfo: IFileStoreInfo;
    columns: Array<IColumn>;
}

export interface IConfigListItem {
    
        id: number;
        value?: string;
        name: string;
        selected?: boolean;
        tooltip?: string;
        visible?: boolean;
        
}

// For now Josh and JC say we are not doing edits so do not fill out the whole class.
export class ConfigurationModel {
    public static NEW_CONFIGURATION_ID: number = -1;
}

export interface IConfigResults {   
    configID: number;
    configChanged: boolean;
    configRenamed: boolean;
    configDeleted: boolean;
}

export interface IObjectMapInfo {
    objects: Array<IeLynxObject>;
    objectMap: Array<IObjectMap>;
}

export interface IObjectMap {
    identifier: string;
    mappedObject: IeLynxObject;
}

export interface ITagType {
    name: string;
    id: number;
}

export interface ITagTypeMap {
    importColumn: IColumn;
    mappedTagType: ITagType;
    eventType: SetPointEventTypeEnum;
}

export interface ITagTypeMapInfo {
    tagTypes: Array<ITagType>;
    tagTypeMap: Array<ITagTypeMap>;
}

export interface IConfiguration {
    columns: Array<IColumn>;
    dateColumn: IColumn;
    dateColumnType: DateColumnTypeEnum;
    fileContainsType: FileContainsTypeEnum;
    fileHasHeaderRow: boolean;
    id: number;
    identifierColumn: IColumn;
    importObjectType: eLynxObjectTypeEnum;
    importType: ImportTypeEnum;
    name: string;
    objectMap: Array<IObjectMap> | undefined;
    tagTypeColumns: Array<IColumn>;
    tagTypeMap: Array<ITagTypeMap>;
    timeColumn: IColumn | undefined;
    timezone: IReferenceTimeZoneDTO;
    attributeName: string;
}

export interface ILogEntry {
    columnID?: number;
    columnName?: string;
    cellValue?: string;
    dateColumnType?: DateColumnTypeEnum;
    importType?: ImportTypeEnum;
    logEntryType: LogEntryTypeEnum;
    identifier?: string;
    object?: IeLynxObject;
    message?: string;
    rowNumber?: number;
    secondaryColumnID?: number;
    secondaryColumnName?: number;
}

// export class LogEntry implements ILogEntry {
//     public columnID?: number;
//     public columnName?: string;
//     public cellValue?: string;
//     public dateColumnType?: DateColumnTypeEnum;
//     public importType?: ImportTypeEnum;
//     public logEntryType: LogEntryTypeEnum;
//     public identifier?: string;
//     public object?: IeLynxObject;
//     public message?: string;
//     public rowNumber?: number;
//     public secondaryColumnID?: number;
//     public secondaryColumnName?: number;

//     constructor(object?: ILogEntry) {
//         if (object) {

//             this.columnID = Utilities.getValueOrNull(object.columnID);
//             this.columnName = Utilities.getValueOrNull(object.columnName);
//             this.cellValue = Utilities.getValueOrNull(object.cellValue);
//             this.dateColumnType = Utilities.getValueOrNull(object.dateColumnType);
//             this.importType = Utilities.getValueOrNull(object.importType);
//             this.logEntryType = Utilities.getValueOrNull(object.logEntryType);
//             this.identifier = Utilities.getValueOrNull(object.identifier);
//             this.object = Utilities.getValueOrNull(object.object);
//             this.message = Utilities.getValueOrNull(object.message);
//             this.rowNumber = Utilities.getValueOrNull(object.rowNumber);
//             this.secondaryColumnID = Utilities.getValueOrNull(object.secondaryColumnID);
//             this.secondaryColumnName = Utilities.getValueOrNull(object.secondaryColumnName);
//         }
//     }

//     public toString(): string {
//         let message: string = "";
//         let columnID: number = this.columnID != null ? this.columnID + 1 : null;

//         switch (this.logEntryType) {
//             case LogEntryTypeEnum.AllTagsProcessed:
//                 break;

//             case LogEntryTypeEnum.IdentifierNotMatched:
//                 message = `Identifier: ${this.identifier} Import Type: ${this.importType} Row Number: ${this.rowNumber} ` +
//                     `Column Index: ${columnID} Column Name: ${this.columnName}`;

//                 break;

//             case LogEntryTypeEnum.InvalidData:
//                 message = `Row Number: ${this.rowNumber} Column Index: ${columnID} Column Name: '${this.columnName}' ` +
//                     `Value: ${this.cellValue}`;

//                 break;

//             case LogEntryTypeEnum.InvalidDateTime:

//                 if (this.dateColumnType == DateColumnTypeEnum.One) {
//                     message = `Row Number: ${this.rowNumber} Date Column Index: ${columnID} Date Column Name: '${this.columnName}' ` +
//                         `Value: ${this.cellValue}`;
//                 }
//                 else {
//                     message = `Row Number: ${this.rowNumber} Date Column Index: ${columnID} Date Column Name: '${this.columnName}' ` +
//                         `Time Column Index: ${this.secondaryColumnID} Time Column Name: ${this.secondaryColumnName} ` +
//                         `Value: ${this.cellValue}`;
//                 }

//                 break;

//             case LogEntryTypeEnum.MissingDateTime:

//                 if (this.dateColumnType == DateColumnTypeEnum.One) {
//                     message = `Row Number: ${this.rowNumber} Date Column Index: ${columnID} Date Column Name: '${this.columnName}'`;
//                 }
//                 else {
//                     message = `Row Number: ${this.rowNumber} Date Column Index: ${columnID} Date Column Name: '${this.columnName}' ` +
//                         `Time Column Index: ${this.secondaryColumnID} Time Column Name: ${this.secondaryColumnName}`;
//                 }

//                 break;

//             case LogEntryTypeEnum.MissingTag:
//                 message = `Row Number: ${this.rowNumber} Column Index: ${columnID} Column Name: '${this.columnName}'`;

//                 break;

//             case LogEntryTypeEnum.NoReadPermissions:
//                 break;

//             case LogEntryTypeEnum.NotActive:
//                 break;

//             case LogEntryTypeEnum.MissingIdentifier:
//                 message = `Row Number: ${this.rowNumber} Column Index: ${columnID} Column Name: '${this.columnName}'`;

//                 break;

//             case LogEntryTypeEnum.ProcessingError:
//                 message = `Identifier: ${this.identifier} Row Number: ${this.rowNumber} Error: ${this.message}`;

//                 break;
//         }
//         return message;
//     }
// }

export interface IProcessImportLog {
    processImportLogs: Array<ILogEntry>;

    getProcessImportLogsHtml?(): string;
}

// export class ProcessImportLog implements IProcessImportLog {

//     public processImportLogs: Array<ILogEntry> = [];

//     constructor(object?: IProcessImportLog) {
//         if (object) {

//             this.processImportLogs = object.processImportLogs
//                 ? object.processImportLogs.map((le: ILogEntry): LogEntry => {
//                     return new LogEntry(le);
//                 })
//                 : new Array<LogEntry>();
//         }
//     }

//     // Dan JavaScript HTML Template
//     public getProcessImportLogsHtml()
//         : string {

//         const groupedImportLogs: Array<IGroupedLogEntries> = this._groupProcessImportLogs()

//         const logHtml: string = `
//             <div class="info-dialog-content">
//                 <ul>
//                     ${groupedImportLogs.map(glet =>
//                     `<li>
//                         <h1>
//                         ${this._getLogEntryTypeName(glet.logEntryType)}
//                         </h1>

//                         <ul>
//                         ${glet.objectGroups.map(gleo =>
//                             `<li>
//                                 <h2>
//                                     ${gleo?.object?.displayText ?? ""}
//                                 </h2>
//                                 ${this._getLogDetail(glet.logEntryType, gleo)}
//                             </li>`
//                         ).join('')}
//                         </ul>
//                     </li>`
//                     ).join('')}
//                 </ul>
//             </div>
//         `;

//         return logHtml;
//     }

//     // Dan JavaScript HTML Template
//     public _getLogDetail(logEntryType: LogEntryTypeEnum, gleo: IGroupedObjectLogs) {
//         let html: string = "";

//         if (logEntryType != LogEntryTypeEnum.NoReadPermissions) {
//             html = 
//                 `
//                 <ul>
//                     ${gleo.logEntries.map(le =>
//                         `<li class="detail">
//                             ${le.toString()}
//                         </li>`
//                     ).join('')}
//                 </ul>`
//         }

//         return html;
//     }

//     private _groupProcessImportLogs():
//         Array<IGroupedLogEntries> {

//         return Enumerable.from(this.processImportLogs)
//             .groupBy(le => le.logEntryType, le => le,
//                 (key: LogEntryTypeEnum, g: linqjs.IEnumerable<ILogEntry>) => {
//                     return {
//                         logEntryType: key,
//                         objectGroups:
//                             Enumerable.from(g.toArray())
//                                 // This is a kludge because I could not get linq.js to group by the full eLynxObject
//                                 //  I had to use a string made up of the object type and object id.
//                                 .groupBy(le => `${le?.object?.objectType}|${le?.object?.id}`, le => le,
//                                     (key: string, g: linqjs.IEnumerable<ILogEntry>) => {
//                                         return {
//                                             // This is a kludge because I could not get linq.js to group by the full eLynxObject
//                                             //  I had to use a string made up of the object type and object id.
//                                             // All the objects should be the same so taking the first one in the list
//                                             //  should work.
//                                             object: g?.firstOrDefault()?.object,
//                                             logEntries: g.toArray()
//                                         }
//                                     })
//                                 .toArray()
//                     }
//                 })
//             .toArray();
//     }

//     private _getLogEntryTypeName(logEntryType: LogEntryTypeEnum): string {

//         let logEntryTypeName: string = "Invalid LogEntryTypeEnum";

//         switch (logEntryType) {

//             case LogEntryTypeEnum.AllTagsProcessed:
//                 logEntryTypeName = i18n.t("dataFileImport.enums.logEntryTypeEnum.allTagsProcessed");
//                 break;
//             case LogEntryTypeEnum.IdentifierNotMatched:
//                 logEntryTypeName = i18n.t("dataFileImport.enums.logEntryTypeEnum.identifierNotMatched");
//                 break;

//             case LogEntryTypeEnum.InvalidData:
//                 logEntryTypeName = i18n.t("dataFileImport.enums.logEntryTypeEnum.invalidData");
//                 break;

//             case LogEntryTypeEnum.InvalidDateTime:
//                 logEntryTypeName = i18n.t("dataFileImport.enums.logEntryTypeEnum.invalidDateTime");
//                 break;

//             case LogEntryTypeEnum.MissingDateTime:
//                 logEntryTypeName = i18n.t("dataFileImport.enums.logEntryTypeEnum.missingDateTime");
//                 break;

//             case LogEntryTypeEnum.MissingTag:
//                 logEntryTypeName = i18n.t("dataFileImport.enums.logEntryTypeEnum.missingTag");
//                 break;

//             case LogEntryTypeEnum.NoReadPermissions:
//                 logEntryTypeName = i18n.t("dataFileImport.enums.logEntryTypeEnum.noReadPermissions");
//                 break;

//             case LogEntryTypeEnum.NotActive:
//                 logEntryTypeName = i18n.t("dataFileImport.enums.logEntryTypeEnum.notActive");
//                 break;

//             case LogEntryTypeEnum.MissingIdentifier:
//                 logEntryTypeName = i18n.t("dataFileImport.enums.logEntryTypeEnum.missingIdentifier");
//                 break;

//             case LogEntryTypeEnum.ProcessingError:
//                 logEntryTypeName = i18n.t("dataFileImport.enums.logEntryTypeEnum.processingError");
//                 break;
//         }

//         return logEntryTypeName;
//     }
// }

export interface IGroupedObjectLogs {
    object: IeLynxObject;
    logEntries: Array<ILogEntry>;
}

export interface IGroupedLogEntries {
    logEntryType: LogEntryTypeEnum;
    objectGroups: Array<IGroupedObjectLogs>;
}
